import React from 'react';
import { formatCurrency } from '@avila-tek/ui/src';
import { TTotal } from '../../../models';

interface ShopcartTotalProps {
  total: Partial<TTotal>;
}

function ShopcartTotal({ total }: ShopcartTotalProps) {
  return (
    <div className="w-full flex my-5">
      <div className="md:ml-auto flex flex-col space-y-3 ">
        <div className="flex justify-between space-x-28 ">
          <span className="text-neutral-warm-500">Subtotal</span>
          <div className="ml-auto text-text-black">
            ${formatCurrency(total.subtotal)}
          </div>
        </div>
        {total.discountTotal > 0 ? (
          <div className="flex justify-between space-x-28 ">
            <span className="text-neutral-warm-500">Descuento</span>
            <div className="ml-auto text-text-black">
              ${formatCurrency(total.discountTotal)}
            </div>
          </div>
        ) : null}
        {total.totalTax > 0 ? (
          <div className="flex justify-between space-x-28 ">
            <span className="text-neutral-warm-500">Impuestos</span>
            <div className="ml-auto text-text-black">
              ${formatCurrency(total.totalTax)}
            </div>
          </div>
        ) : null}
        <div className="flex justify-between space-x-28 ">
          <span className="text-text-black text-lg font-semibold">Total</span>
          <div className="ml-auto text-purple-300 text-lg font-semibold">
            ${formatCurrency(total.total)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShopcartTotal;
